import { CreateTokenCardData } from '@stripe/stripe-js';

const CardForm = () => {};
type CardFormView = {};
const createPaymentMethod = () => {};
const initStripe = () => {};

export {
  CardForm,
  CardFormView,
  createPaymentMethod,
  CreateTokenCardData as createToken,
  initStripe,
};
